// Periodic-table-cell glyph. The unique product motif. Used in 3 places only
// (per brand-system-v1.md): wordmark accent, example-card tag, audit-trail signature.
// Don't use as decoration anywhere else.

import type { CSSProperties } from 'react';

type Size = 'sm' | 'md' | 'lg';

const SIZES: Record<Size, { wh: string; sym: string; numTop: string; numRight: string; numFs: string; symMt: string }> = {
  sm: { wh: 'w-7 h-7', sym: 'text-[14px]', numTop: 'top-[3px]', numRight: 'right-[4px]', numFs: 'text-[7px]', symMt: 'mt-[4px]' },
  md: { wh: 'w-8 h-8', sym: 'text-[15px]', numTop: 'top-[3px]', numRight: 'right-[4px]', numFs: 'text-[7px]', symMt: 'mt-[4px]' },
  lg: { wh: 'w-11 h-11', sym: 'text-[20px]', numTop: 'top-1', numRight: 'right-1.5', numFs: 'text-[9px]', symMt: 'mt-[7px]' },
};

interface Props {
  symbol: string;
  atomicNumber: number;
  size?: Size;
  className?: string;
  style?: CSSProperties;
}

export function ElementCell({ symbol, atomicNumber, size = 'sm', className = '', style }: Props) {
  const s = SIZES[size];
  return (
    <span
      className={`relative inline-flex flex-col items-center justify-center bg-ink text-bg rounded font-display leading-none ${s.wh} ${className}`}
      style={style}
    >
      <span className={`absolute font-mono text-accent ${s.numTop} ${s.numRight} ${s.numFs}`}>{atomicNumber}</span>
      <span className={`tracking-tight2 ${s.sym} ${s.symMt}`}>{symbol}</span>
    </span>
  );
}
